export default __webpack_public_path__ + "static/media/weddingGray.c711c24a.svg";